<ui-form-text (keydown.enter)="fillDataLayer(currentFilter())" [formControl]="filterControl" [data]="filterData"></ui-form-text>

<div class="actions">
  <ui-button (clicked)="fillDataLayer(currentFilter())">Refresh</ui-button>
  <ui-button (clicked)="clearDataLayer()">clear Datalayer</ui-button>
</div>

@for (item of dataLayer(); track item; let first = $first) {
  @defer (on viewport) {
    <ui-expander [title]="item.event" [expanded]="first">
      <pre>{{ item | json }}</pre>
    </ui-expander>
  } @placeholder () {
    <span>loading</span>
  }
}
